import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_PROMOTIONS_DATA, FETCH_PROMOTIONS_EDIT_DATA } from "./actionTypes";
import {
  fetchPromotionsSuccess,
  fetchPromotionsFailure,
  fetchPromotionsEditSuccess,
  fetchPromotionsEditFailure,
} from "./actions";

function* fetchPromotionsDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/promotions",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchPromotionsSuccess(response.data));
  } catch (error) {
    yield put(fetchPromotionsFailure(error.message));
  }
}

function* fetchPromotionsEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/promotions/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(response);
    yield put(fetchPromotionsEditSuccess(response.data));
  } catch (error) {
    yield put(fetchPromotionsEditFailure(error.message));
  }
}

export default function* promotionsSaga() {
  yield takeEvery(FETCH_PROMOTIONS_DATA, fetchPromotionsDataSaga);
  yield takeEvery(FETCH_PROMOTIONS_EDIT_DATA, fetchPromotionsEditDataSaga);
}
